import { Link, useHistory, useParams } from 'react-router-dom'
import ContentHeader from '../Layout/ContentHeader'
import { useLoading } from '../../LoadingOverlay/LoadingOverlayContext'
import { FormProvider, useForm } from 'react-hook-form'
import InputController from '../Global/InputController'
import Box from '../Global/Box'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { useEffect, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import {
  CREATE_GROUP,
  GET_ALL_REPORT_GROUPS_BY,
  GET_ONE_GROUP,
  UPDATE_GROUP,
} from '../../graphql/Catalog/ReportGroups/reportGroups'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import CheckboxCustom from '../Global/Checkbox/CheckboxCustom'

// const backPage = '/ReportGroups/Groups'

const refetchGroups = {
  query: GET_ALL_REPORT_GROUPS_BY,
  variables: {
    offset: 0,
    limit: 10,
    searchQuery: null,
  },
}

const extensions_allowed_image = ['.jpg', '.jpeg', '.png', '.svg']
const sizeMaxFile = 5 //MB

const ReportGroupsNew = () => {
  //HOOKS:
  const { id: _id } = useParams()
  const history = useHistory()
  const [backPage, setBackPage] = useState(false)
  const [allowCreation, setAllowCreation] = useState({
    allow_create_in_app: false,
    allow_create_in_web: false,
    show_system: false,
  })
  const { showLoading, hideLoading } = useLoading()

  //STATES:
  const [file, setFile] = useState(null)
  const [icon, setIcon] = useState(null)

  //MUTATIONS:
  const [createGroup] = useMutation(CREATE_GROUP, {
    refetchQueries: [refetchGroups],
  })

  const [updateGroup] = useMutation(UPDATE_GROUP, {
    refetchQueries: [refetchGroups],
  })

  //QUERYS:
  const { data, loading, error } = useQuery(GET_ONE_GROUP, {
    variables: {
      getOneGroupId: _id ? parseInt(_id) : -1,
    },
    fetchPolicy: 'no-cache',
  })
  //USE-EFFECTS:
  useEffect(() => {
    if (_id) {
      // Perform your query here to fetch the data
      if (!loading) {
        if (error)
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })

        reset({
          name: data.getOneGroup.name,
          description: data.getOneGroup.description,
          icon: data.getOneGroup.icon,
          allow_create_in_app: data.getOneGroup.allow_create_in_app,
          allow_create_in_web: data.getOneGroup.allow_create_in_web,
          show_system: data.getOneGroup.show_system,
        })
        setAllowCreation({
          allow_create_in_app: data.getOneGroup.allow_create_in_app,
          allow_create_in_web: data.getOneGroup.allow_create_in_web,
          show_system: data.getOneGroup.show_system,
        })
        let icon = data.getOneGroup.icon
        if (
          data.getOneGroup?.IconOfGroup?.url &&
          data.getOneGroup?.IconOfGroup?.url !== ''
        ) {
          icon = data.getOneGroup?.IconOfGroup?.url
        }
        setIcon(icon)
      }
    } else {
      reset({
        name: '',
        description: '',
        icon: '',
        allow_create_in_app: false,
        allow_create_in_web: false,
        show_system: false,
      })
      setAllowCreation({
        allow_create_in_app: false,
        allow_create_in_web: false,
        show_system: false,
      })
    }
  }, [_id, loading, error, data])

  //FORM:
  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Campo requerido'),
    description: Yup.string().required('Campo requerido'),
  })

  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  //FUNCTIONS:
  const handleFile = async (e) => {
    if (!e.target.files[0]) return

    const fileName = e.target.files[0].name.toLowerCase()
    const lastDot = fileName.lastIndexOf('.')
    const extension = fileName.slice(lastDot, fileName.length)

    if (extensions_allowed_image.indexOf(extension) === -1) {
      setFile(null)
      return toastSweetAlert({
        mode: 'error',
        message: `Solo se admite ${extensions_allowed_image.join(', ')}`,
      })
    }

    if (e.target.files[0].size / 1048576 > sizeMaxFile) {
      setFile(null)
      return toastSweetAlert({
        mode: 'error',
        message: `El archivo no puede superar los ${sizeMaxFile}MB`,
      })
    }

    setFile(e.target.files[0])
  }

  const onSubmit = async (data) => {
    showLoading()
    try {
      if (_id) {
        await updateGroup({
          variables: {
            input: {
              name: data.name,
              description: data.description,
              icon: data.icon,
              file: file,
              allow_create_in_app: allowCreation.allow_create_in_app,
              allow_create_in_web: allowCreation.allow_create_in_web,
              show_system: allowCreation.show_system,
            },
            updateGroupId: parseInt(_id),
          },
        })
      } else {
        await createGroup({
          variables: {
            input: {
              name: data.name,
              description: data.description,
              icon: data.icon,
              file: file,
              allow_create_in_app: allowCreation.allow_create_in_app,
              allow_create_in_web: allowCreation.allow_create_in_web,
              show_system: allowCreation.show_system,
            },
          },
        })
      }

      return toastSweetAlert(
        {
          mode: 'ok',
          message: _id
            ? 'Grupo actualizado correctamente'
            : 'Grupo creado correctamente',
        },
        history.push(backPage)
      )
    } catch (error) {
      console.error(error)
      toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <ContentHeader
        title=""
        breadcrumb=""
        // breadcrumb="custom"
        // titleContent={
        //   <div className="col-12 col-sm-6">
        //     <Link className="btn btn-migrates-white" to={backPage}>
        //       <i className="fas fa-long-arrow-alt-left" /> Atrás
        //     </Link>
        //   </div>
        // }
        // breadcrumbContent={
        //   <div className="col-12 col-sm-6">
        //     <ol className="breadcrumb float-sm-right">
        //       <li className="breadcrumb-item">
        //         <Link to={backPage}>Grupos de Reportes / </Link>
        //       </li>
        //       <li className="breadcrumb-iteem active">
        //         {` `}
        //         {_id ? 'Editar' : 'Agregar'}
        //       </li>
        //     </ol>
        //   </div>
        // }
        windowTitle={`${_id ? 'Editar' : 'Agregar'} configuracion App`}
      />

      <FormProvider {...methods}>
        <form className="px-3" onSubmit={handleSubmit(onSubmit)}>
          <Box
            title="Grupo"
            // btnRedPath={backPage}
            // btnRedTxt="Cancelar"
            errors={errors}
            btnSubmit={true}
            BackPageHeader
            setBackPage={setBackPage}
            content={
              <>
                <div className="mb-3">
                  <div className="row">
                    <div className="mb-3 col-12 col-sm-6">
                      <InputController
                        label="Nombre *"
                        name="name"
                        control={control}
                        inputType="text"
                        placeholderTxt="Nombre del Grupo"
                        required
                      />
                      <InputController
                        label="Icono"
                        name="icon"
                        control={control}
                        inputType="hidden"
                        placeholderTxt="Icono del Grupo"
                        valueManual=""
                      />
                    </div>
                    <div className="mb-3 col-12 col-sm-6 d-flex flex-row">
                      {icon && (
                        <img src={icon} alt="icon" width="30px" height="30px" />
                      )}

                      <div className="w-100 pl-2">
                        <InputController
                          label={`Icono (${extensions_allowed_image.join(
                            ', '
                          )}) Max: ${sizeMaxFile} MB`}
                          inputType="file"
                          formatAccept="image/*"
                          alidateFormatMsg={`Solo se admite ${extensions_allowed_image.join(
                            ', '
                          )}`}
                          name="file"
                          control={control}
                          validateFormat="imageavatar"
                          changeAction={(e) => handleFile(e)}
                        />
                      </div>
                    </div>
                    <div className="mb-3 col-12">
                      <InputController
                        label="Descripción *"
                        name="description"
                        inputType="textarea"
                        rows={3}
                        placeholderTxt="Breve descripción del Grupo"
                        control={control}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <h3>Permisos</h3>
                  <div className="col-12 col-sm-4 mb-3">
                    <CheckboxCustom
                      label="Permitir creación de Reportes en la App"
                      name="allow_create_in_app"
                      control={control}
                      value={true}
                      labelInput="allow_create_in_app"
                      classNameWrap="pt-4"
                      onChange={(e) => {
                        setAllowCreation((prev) => ({
                          ...prev,
                          allow_create_in_app: e.target.checked,
                        }))
                      }}
                    />
                  </div>
                  <div className="col-12 col-sm-4 mb-3">
                    <CheckboxCustom
                      label="Permitir creación de Reportes en la Web"
                      name="allow_create_in_web"
                      control={control}
                      value={true}
                      labelInput="allow_create_in_web"
                      classNameWrap="pt-4"
                      onChange={(e) => {
                        setAllowCreation((prev) => ({
                          ...prev,
                          allow_create_in_web: e.target.checked,
                        }))
                      }}
                    />
                  </div>
                  <div className="col-12 col-sm-4 mb-3">
                    <CheckboxCustom
                      label="Mostrar en sistema"
                      name="show_system"
                      control={control}
                      value={true}
                      labelInput="show_system"
                      classNameWrap="pt-4"
                      onChange={(e) => {
                        setAllowCreation((prev) => ({
                          ...prev,
                          show_system: e.target.checked,
                        }))
                      }}
                    />
                  </div>
                </div>
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}
export default ReportGroupsNew
